import { Box, Button, Divider, IconButton, Link, styled, Tooltip } from '@mui/material';
import { OrderJobAsset } from '../../../redux/slices/slice_types';
import { selectCanLinkNewAsset } from '@/redux/selectors/authSelectors';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { useAppSelector } from '@/redux/hooks';
import { Dialog } from '@/components/_common';
import { useState } from 'react';
import TitledList from './TitledList';

interface ManageAssetProps {
  data: OrderJobAsset;
  disabled: boolean;
}

const ManageAsset = ({ data, disabled }: ManageAssetProps) => {
  const canLinkNewAsset = useAppSelector(selectCanLinkNewAsset);
  const [open, setOpen] = useState(false);
  // KYLE: Per kfung we are hardcoding these for now. We can make them more generic in teh future if needed
  const assetLabel = data?.sub_type?.toLowerCase() === 'metadata' ? 'Metadata' : data?.type?.toLowerCase() === 'artwork' ? 'Artwork' : 'Asset';

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);
  const UIAttributes = data.validation_data?.ui_attributes;

  const onErrorClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    handleOpen();
  };

  return (
    <ButtonContainer>
      {data.validation_data?.is_metadata_valid === false && (
        <Tooltip title="View Errors">
          <IconButton color={data?.validation_data?.errors?.length > 0 ? 'error' : 'warning'} sx={{ mr: 1 }} onClick={onErrorClick}>
            <PolarisIcon icon="error" />
          </IconButton>
        </Tooltip>
      )}
      <Button
        component={Link}
        href={data.info?.action_url}
        target="_blank"
        color="primary"
        disabled={disabled || !canLinkNewAsset}
        variant={disabled ? 'outlined' : 'contained'}
        sx={{ whiteSpace: 'nowrap', textTransform: 'capitalize', width: '100%' }}
        endIcon={<PolarisIcon icon="link" />}
        onClick={(e) => e.stopPropagation()}
      >
        Manage {assetLabel}
      </Button>
      {data.validation_data?.is_metadata_valid === false && UIAttributes && (
        <Dialog
          open={open}
          onCancel={handleClose}
          showX
          hideCancel
          title="Validation Errors"
          showButtons={false}
          onSubmit={handleClose}
          submitText="Close"
        >
          <Divider sx={{ mb: '2rem' }} />
          <TitledList data={data.validation_data.errors} UIAttributes={UIAttributes} type="error" />
          <TitledList data={data.validation_data.warnings} UIAttributes={UIAttributes} type="warning" />
        </Dialog>
      )}
    </ButtonContainer>
  );
};
export default ManageAsset;

const ButtonContainer = styled(Box)`
  display: flex;
`;
